export default "__VITE_ASSET__BIpvzUWk__"